export const ArrowLeft = ({ width, height, viewBox, fill, styles }) => {
  return (
    <svg
      width={width || '24'}
      height={height || '24'}
      viewBox={viewBox || '0 0 24 24'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles}
    >
      <path
        d="M16.16 7.41L11.58 12L16.16 16.59L14.75 18L8.75 12L14.75 6L16.16 7.41Z"
        fill={fill || '#BBBEC6'}
      />
    </svg>
  );
};
